<script>
    import { onMount, beforeUpdate, onDestroy } from "svelte";
    import { Router, Route } from "svelte-routing";
    import Sidebar from "./components/Sidebar.svelte";
    import ChatArea from "./components/ChatArea.svelte";
    import LoginPopover from "./components/LoginPopover.svelte";
    import {
        db,
        userID,
        clientUserID,
        splashScreenArtUrl,
        assistantIconUrl,
        textCopy,
        modesData,
        emailHash,
        isModesAvailable,
        isWLtriggered,
        countDownTimer,
        showCountdown,
        footerLinkData,
        isStatelessUserFlag,
        daChatToken,
    } from "./stores.js"; // Import the store

    // Firebase configuration and initialization
    const firebaseConfig = {
        apiKey: "AIzaSyCvvmyAKG3Tj2-2B8AeKQyS93LCnKKMaOg",
        authDomain: "workwork-bb2a0.firebaseapp.com",
        projectId: "workwork-bb2a0",
        storageBucket: "workwork-bb2a0.appspot.com",
        messagingSenderId: "819540228894",
        appId: "1:819540228894:web:18b45a0e93e70605a5e70f",
    };
    firebase.initializeApp(firebaseConfig);
    db.set(firebase.firestore()); // Set the store value

    let chatToken;
    let showLoginPopover = true;

    function handleLogin(event) {
//        console.log("handleLogin event received", event.detail);

        const { userEmailHash, newUser } = event.detail;

        // Log before and after setting showLoginPopover
//        console.log("Before setting showLoginPopover:", showLoginPopover);
        showLoginPopover = false;
//        console.log("After setting showLoginPopover:", showLoginPopover);

        emailHash.set(userEmailHash);
//        console.log("emailHash set with value", userEmailHash);
//        console.log("New user:", newUser);

        const path = window.location.pathname.split("/");
        chatToken = path[path.length - 1];
        if (chatToken) {
            fetchData(chatToken);
        }
    }
    /*
    function closeLoginPopover() {
        showLoginPopover = false;
    }
*/



    function handleLogin2(event) {
        const { completeShit } = event.detail;

        showLoginPopover = false;

        const csPath = completeShit.deploymentData;
        const csPathModes = completeShit.modesData;

        splashScreenArtUrl.set(csPath.splashScreenArtUrl);
        assistantIconUrl.set(csPath.assistantIconUrl);
        textCopy.set(csPath.textCopy); // Store the textCopy
        // Preload splash screen image
        preloadImage(csPath.splashScreenArtUrl);
        preloadImage(csPath.assistantIconUrl); // Preload assistant icon
        console.log(
            "Fetched URLs:",
            csPath.splashScreenArtUrl,
            csPath.assistantIconUrl,
        );

        isStatelessUserFlag.set(true);


//        console.log("This is csPathModes:", csPathModes);
        if (csPathModes && Object.keys(csPathModes).length > 0) {
            const modesMap = new Map(Object.entries(csPathModes));
            modesData.set(modesMap); // Update the Svelte store with the new data
        }


        const path = window.location.pathname.split("/");
        chatToken = path[path.length - 1];
        daChatToken.set(chatToken);


        const footerLink = csPath.footerLink;
        if (footerLink && footerLink.precedingText && footerLink.linkText && footerLink.linkDestinationUrl) {
          footerLinkData.set(footerLink); // Set the Svelte store with the footer link data
        }
        const boolstate = csPath.modesAvailableFlag === true
        isModesAvailable.set(boolstate);
        changeDocumentTitle(csPath.name); // Assuming 'name' is the field for the deployment name




//        emailHash.set(userEmailHash);



    }






    //after fuckery changes
    // Function to preload image

    function preloadImage(url, modeId = null) {
        console.log("Preloading image:", url, "with modeId:", modeId);

        const img = new Image();
        img.onload = () => {
            console.log("Image preloaded successfully:", url);
            if (modeId) {
                updateModeDataValidity(modeId, true);
            }
        };
        img.onerror = () => {
            console.error("Failed to preload image:", url);
            if (modeId) {
                updateModeDataValidity(modeId, false);
            }
        };
        img.src = url;
    }

    function updateModeDataValidity(modeId, isValid) {
        console.log(`Updating validity for modeId ${modeId} to ${isValid}`);
        if (!modeId) return;

        modesData.update((currentModes) => {
            console.log("Before update:", currentModes);
            const newModes = new Map(currentModes);
            const modeData = { ...newModes.get(modeId) };
            modeData.loadingState = isValid ? "loaded" : "error";
            newModes.set(modeId, modeData);
            console.log("After update:", newModes);
            return newModes;
        });
    }

    async function fetchData(chatToken) {
        console.log("Fetching data for chatToken:", chatToken);
        const docRef = $db.collection("clientUserChatTokens").doc(chatToken);
        const doc = await docRef.get();
        if (doc.exists) {
            clientUserID.set(doc.data().clientUserID);
            userID.set(doc.data().userID);
            if ($userID && $clientUserID) {
                await fetchDeploymentData();
            }
        } else {
            console.error("No such document for chatToken:", chatToken);
        }
    }

    function changeDocumentTitle(title) {
        document.title = title;
    }


    async function fetchDeploymentData() {
    try {
        // Fetch deployment data first
        const clientUserRef = $db
            .collection("users")
            .doc($userID)
            .collection("deploymentUserData")
            .doc($clientUserID);


        const clientUserDoc = await clientUserRef.get();
//        console.log("We bouttaGoIN");
        if (clientUserDoc.exists && clientUserDoc.data()) {
  //          console.log("We got in");
            const clientUserData = clientUserDoc.data();
            const deploymentIDs = clientUserData.deploymentID;

            if (deploymentIDs && deploymentIDs.length > 0) {
    //            console.log("We got deepa in");
                // Declare deploymentID in a scope accessible to the rest of the function
                const deploymentID = deploymentIDs[0];
                await fetchSplashScreenData(deploymentID);

                // Now fetch the deploymentIDData
                const deploymentIDDataRef = $db
                    .collection("users")
                    .doc($userID)
                    .collection("deploymentIDData")
                    .doc(deploymentID);
                const deploymentIDDataDoc = await deploymentIDDataRef.get();
                if (deploymentIDDataDoc.exists) {
                    const deploymentIDData = deploymentIDDataDoc.data();
                    const boundModes = deploymentIDData.boundModes;
                    console.log("We fonna set boundModes?")
                    fetchModesData(boundModes); // Call fetchModesData with boundModes

                    //let's do this shit here
                    const footerLink = deploymentIDData.footerLink;
                    if (footerLink && footerLink.precedingText && footerLink.linkText && footerLink.linkDestinationUrl) {
                      footerLinkData.set(footerLink); // Set the Svelte store with the footer link data
                    }

                    // Update the store
//                    console.log("wesetting modesAvailable Flag");
                    const boolstate = deploymentIDData.modesAvailableFlag === true
                    isModesAvailable.set(boolstate);
//                    console.log("This is modesAvailable flag:", boolstate);
                    changeDocumentTitle(deploymentIDData.name); // Assuming 'name' is the field for the deployment name
                }
                
                /* Commented out because we doing it in popOver.svelte
                // Check for emailConfirmed field in clientSubUsers collection
                const clientSubUsersRef = clientUserRef.collection("clientSubUsers");
                const clientSubUsersSnapshot = await clientSubUsersRef.get();
                let emailConfirmedExists = false;
                clientSubUsersSnapshot.forEach((doc) => {
                    if (doc.exists && 'emailConfirmed' in doc.data()) {
                        emailConfirmedExists = true;
                    }
                });

                // Set the isWLtriggered store based on the existence of emailConfirmed field
                isWLtriggered.set(emailConfirmedExists);
                console.log("This is the WLT thing:", isWLtriggered);
                */

                }
        } else {
            console.error("Client user document does not exist or has no data");
        }
//        console.log("here's prolblematic shit:", $userID, $clientUserID, $emailHash);
        // Setup countdown timer based on user-specific document
        const userDocRef = $db.collection("users")
                              .doc($userID)
                              .collection("deploymentUserData")
                              .doc($clientUserID)
                              .collection("clientSubUsers")
                              .doc($emailHash);
        
        userDocRef.onSnapshot(doc => {
            const data = doc.data();

            // Use optional chaining to safely access nested properties
            showCountdown.set(!!data?.usageCapBus?.courtesyMessage === true);
            console.log("This is courtesyMessage Thing", !!data?.usageCapBus?.courtesyMessage === true);

            if (data?.usageCapBus?.courtesyMessage) {
                const now = new Date().getTime();
                // Make sure to check if timeStart exists and is a valid Firestore Timestamp before calling toDate()
                const startTime = data.usageCapBus.timeStart?.toDate()?.getTime(); 
                if (startTime) {
                    const endTime = startTime + data.usageCapBus.timeLimit; 
                    const remainingTime = endTime - now;

                    if (remainingTime > 0) {
                        countDownTimer.set(remainingTime);
                    } else {
                        countDownTimer.set(0);
                    }
                } else {
                    // Handle case where startTime is not available
                    countDownTimer.set(0);
                }
            } else {
                countDownTimer.set(0);
            }

            // Check for hasExceeded and courtesyMessage using optional chaining
            if (data?.usageCapBus?.hasExceeded && !data?.usageCapBus?.courtesyMessage) {
                alert("You are on your last message before you exceed your premium usage. Your premium usage will refresh after the 12hr countdown timer reaches 0, any message after your next one will be using a cheap ai model.");
            }
        });


    } catch (error) {
        console.error("Error in fetchAndSetupCountdownTimer:", error);
        console.log("annoyingss");
    }
    }

    async function fetchSplashScreenData(deploymentID) {
        const deploymentRef = $db
            .collection("users")
            .doc($userID)
            .collection("deploymentIDData")
            .doc(deploymentID);

        const deploymentDoc = await deploymentRef.get();
        if (deploymentDoc.exists && deploymentDoc.data()) {
            const data = deploymentDoc.data();
            splashScreenArtUrl.set(data.splashScreenArtUrl);
            assistantIconUrl.set(data.assistantIconUrl);
            textCopy.set(data.textCopy); // Store the textCopy
            // Preload splash screen image
            preloadImage(data.splashScreenArtUrl);
            preloadImage(data.assistantIconUrl); // Preload assistant icon
            console.log(
                "Fetched URLs:",
                data.splashScreenArtUrl,
                data.assistantIconUrl,
            );
        } else {
            console.log("Deployment document does not exist or has no data");
        }
    }

    async function fetchModesData(boundModes) {
        console.log("we hadnlin it in popUp now.")
        /*
        if (!boundModes || boundModes.length === 0) {
            console.log("No bound modes to fetch.");
            return;
        }

        try {
            const modesDataRef = $db
                .collection("users")
                .doc($userID)
                .collection("modesData");
            let modesDataMap = new Map();

            // Fetch only the documents with IDs in boundModes
            for (const modeId of boundModes) {
                const doc = await modesDataRef.doc(modeId).get();
                if (doc.exists) {
                    const data = doc.data();
                    modesDataMap.set(doc.id, {
                        modeName: data.modeName,
                        assistantIconUrl: data.assistantIconUrl,
                        id: doc.id,
                        lastModified: data.lastModified.toDate(),
                    });

                    if (data.assistantIconUrl) {
                        preloadImage(data.assistantIconUrl, modeId);
                    }
                }
            }

            modesData.set(modesDataMap);
        } catch (error) {
            console.error("Error fetching modes data:", error.message);
        }*/
    }

    // Reactive statement to update chatToken when URL changes
    $: {
        console.log("Route switched, urlToken changed.");
        const path = window.location.pathname.split("/");
        const newChatToken = path[path.length - 1];
        if (newChatToken && newChatToken !== chatToken) {
            chatToken = newChatToken;
            //fetchData(chatToken);
        }
    }
    /*
    onMount(() => {
        const path = window.location.pathname.split("/");
        chatToken = path[path.length - 1];
        if (chatToken) {
            fetchData(chatToken);
        }
    });*/


/*
  function adjustMainHeight() {
    const mainElement = document.querySelector('main');
    if (mainElement) {
      mainElement.style.height = `${window.innerHeight}px`;
    }
  }

  onMount(() => {
    adjustMainHeight();
    window.addEventListener('resize', adjustMainHeight);
    // Clean up
    return () => {
      window.removeEventListener('resize', adjustMainHeight);
    };
  });
*/


/*
  function adjustLayout() {
    const estimatedNavBarHeight = 200; // An estimated average height of the navigation bar
    const viewportHeight = window.innerHeight;
    const usableHeight = viewportHeight - estimatedNavBarHeight; // Subtract the estimated navigation bar height
    document.querySelector('main').style.minHeight = `${usableHeight}px`; // Adjust the min-height accordingly
  }

  onMount(() => {
    adjustLayout(); // Adjust layout when component mounts
    window.addEventListener('resize', adjustLayout); // Adjust layout on resize

    return () => {
      window.removeEventListener('resize', adjustLayout); // Clean up listener on component destruction
    };
  });

  */

</script>

<Router>
    <main>
        <Sidebar />
        <Route path="/chat">
            <ChatArea />
        </Route>
        <Route path="/chat/:token">
            <ChatArea token={chatToken} />
        </Route>
    </main>
</Router>

{#if showLoginPopover}
    <!-- Pass the chatToken to LoginPopover component -->
    <LoginPopover {chatToken} on:login={handleLogin} on:login2={handleLogin2}/>
{/if}

<style>
    :global(html, body) {
        height: -webkit-fill-available;
        margin: 0;
        padding: 0;
    }

    :global(body) {
        display: flex;
        flex-direction: column;
    }

    main {
        display: flex;
        flex: 1;  /* This makes sure that the main tag expands to fill available space without necessarily making it scrollable */
        overflow: hidden;  /* Prevents main from becoming a scroll container */
    }
</style>

